import React, { useState, useEffect } from 'react'
import ViewWidget from '../viewWidget'
import { useGlobalStore } from '../../../../../store'
import { generateSnapshotWidgetRowsAndColsFunc } from '../../../../../util'
import { WidgetOuterWrapper, WidgetInnerWrapper, Wrapper } from './style'

const ReportViewSnapshot = ({data=[], id, onClickAddContent, onClickEditContent}) => {
  const [widgetObject, setWidgetObject] = useState({})
    const { isPPTModalActive } = useGlobalStore()

  // let wrapperWidth = document.getElementById(id).getBoundingClientRect().width - 40
  let wrapperWidth = window.innerWidth - 54
  if(isPPTModalActive) { wrapperWidth = 1300 }

  const onClick = (d) => {
    onClickAddContent(d)
  }

  const onEditClick = (d) => {
    onClickEditContent(d)
  }

  const groupingRows = (arr) => {
    let array1 = arr
    let array2 = [[]]
    let counter = 0
    let hwCount = 0
    for (let i = 0; i < array1.length; i++) {
      const hw = [...array1[i]].map(d => d.height * d.width).reduce((acc, val) => acc + val, 0);
      hwCount += hw

      if(hwCount > 0){
        if(hwCount < 12){
          array2[counter].push(array1[i])
        } else if(hwCount === 12){
          array2[counter].push(array1[i])
          hwCount = 0
          counter++
          array2.push([])
        }
      }
    }
    return array2
  }

  const getSnapshotRowStyle = () => {
    const w = (widgetObject?.data?.[0] || []).map(d => d.width).reduce((acc, val) => acc + val, 0);
    let obj = {gridTemplateColumns: widgetObject.gridTemplateColumns, display: (w < 4) ? 'flex' : 'grid'}
    if(isPPTModalActive){
      obj = {...obj, height: '570px'}
    }
    return obj
  }

  useEffect( () => {
    const updatedData = generateSnapshotWidgetRowsAndColsFunc(data, 'view', wrapperWidth)
    setWidgetObject(updatedData)
  }, [])

  return (
    <Wrapper style={{width: wrapperWidth+'px'}}>
      <WidgetOuterWrapper className='gridOuterContainer'>
        {
          widgetObject && widgetObject?.data?.length > 0 && groupingRows(widgetObject.data).map((arr, i) => {
            return (
              <WidgetInnerWrapper key={`snapshot_I_${i}`} className='gridInnerContainer snapshotRow' style={getSnapshotRowStyle()}>
                {
                  arr.map((d, j) => {
                    return (
                      <React.Fragment key={`snapshot_J_${j}`}>
                        {d.map((obj, k) => 
                          (<ViewWidget defaultType='NA' key={`snapshot_K_${k}`} data={obj} row={j} type={obj?.type} onClick={onClick} onEditClicked={onEditClick} />)
                        )}
                      </React.Fragment>
                    )
                  })
                }
              </WidgetInnerWrapper>
            )
          })
        }
      </WidgetOuterWrapper>
    </Wrapper>
  )
}

export default ReportViewSnapshot
